import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/images/more_info.svg'


const _withScopeId = n => (_pushScopeId("data-v-dadcaf7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "relative"
}
const _hoisted_2 = {
  key: 2,
  class: "relative cursor-pointer w-4 h-4 ml-1",
  src: _imports_0,
  alt: "moreInfo"
}

import { ref, useSlots } from 'vue'
interface Props {
  info?: string
  isPosition?:boolean
  infoClass?: string
  isLeft?:boolean
  contentClass?:string
}

export default /*#__PURE__*/_defineComponent({
  props: {
    info: null,
    isPosition: null,
    infoClass: null,
    isLeft: null,
    contentClass: null
  },
  setup(__props: any) {


const slots = useSlots()
const hoverd = ref(false)
let timer = null as any
const handleMouseOver = () => {
  hoverd.value = true
  timer && clearTimeout(timer)
}
const handleMouseLeave = () => {
  timer && clearTimeout(timer)
  timer = setTimeout(() => {
    hoverd.value = false
  }, 150)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "relative",
    onMouseover: handleMouseOver,
    onMouseleave: handleMouseLeave
  }, [
    (__props.info)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([__props.infoClass, "cursor-pointer"])
        }, _toDisplayString(__props.info), 3))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_unref(slots).info)
            ? _renderSlot(_ctx.$slots, "info", { key: 0 })
            : (_unref(slots).icon)
              ? _renderSlot(_ctx.$slots, "icon", { key: 1 })
              : (_openBlock(), _createElementBlock("img", _hoisted_2))
        ])),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(["absolute z-40 w-80 hoverInfoBox", [__props.isPosition ? 'left-36' : __props.contentClass ? __props.contentClass : `bottom-4 z-40 w-80 ${ __props.isLeft ? 'left-0' : `-right-9`}`]]),
          style: _normalizeStyle(__props.isPosition ? 'bottom:115px;' : '')
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["relative mb-5 text-white rounded-xl hoverInfo", __props.isPosition ? 'p-2 text-14px text-left' : 'p-3 text-12px  moreInfoBox whitespace-normal text-left']),
            style: _normalizeStyle(__props.isPosition ? 'background: rgba(20, 24, 20, 0.92);' : '')
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 6),
          _createElementVNode("div", {
            class: _normalizeClass(["absolute arrow", __props.isPosition ? 'infoArrowRadius left-3.5' : `arrowRadius ${__props.isLeft ? 'left-4' : ' right-9' } z-30`])
          }, null, 2)
        ], 6), [
          [_vShow, hoverd.value]
        ])
      ]),
      _: 3
    })
  ], 32))
}
}

})